import styled from "styled-components";

const Tooltip = styled.div`
  position: absolute;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  left: ${({ left }) => left || "50%"};
  bottom: ${({ bottom }) => bottom || "100%"};
  transform: translateX(-50%) translateY(-6px);

  padding: ${({ padding }) => padding || "7px 15px"};
  border-radius: 8px;
  font-size: ${({ fontSize }) => fontSize || "12px"};
  color: ${({ textColor }) => textColor || "#fff"};
  border: ${({ border }) => border || "1px solid #1f2939"};
  background-color: ${({ bgColor }) => bgColor || "#1f2939"};
  min-width: ${({ width }) => width || "120px"};
  height: ${({ height }) => height || "30px"};
  width: max-content;
  z-index: 999999999 !important;

  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease;

  /* Arrow */
  &::before,
  &::after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &::after {
    border-top-color: ${({ bgColor }) => bgColor || "#1f2939"};
    border-width: 5px;
    margin-left: -5px;
  }

  &::before {
    border-top-color: ${({ bgColor }) => bgColor || "#1f2939"};
    border-width: 6px;
    margin-left: -6px;
  }
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
`;

const CommonTooltip = ({ tooltipText, children, ...props }) => (
  <TooltipWrapper>
    {children}
    <Tooltip {...props}>{tooltipText}</Tooltip>
  </TooltipWrapper>
);

export default CommonTooltip;


